// extracted by mini-css-extract-plugin
export var container = "_my-0";